import store from '../../redux/store';
import { RootState } from '../../redux/store';

export function validateEntitlements(entitlements: string[], comparator: 'or' | 'and' = 'or'): boolean {
    if (entitlements.length === 0) return true;

    const userEntitlements: string[] = (store.getState() as RootState).authorization?.entitlements ?? [];

    if (comparator === 'and') {
        return entitlements.every((e) => userEntitlements.includes(e));
    }

    return entitlements.some((e) => userEntitlements.includes(e));
}

window.validateEntitlements = validateEntitlements;
